import { 
    CreateCityAttributesData, 
    UpdateCityAttributesData, 
    GetDeleteCityAttributesData, 
    CityAttributes
} from "@/types";
import { PostRequest } from "./requests";

// Create City Attributes
export const createCityAttributes = async (data: CreateCityAttributesData) => {
    try {
        return await PostRequest("/api/city_attributes/create", data);
    } catch (error) {
        console.error("Error in createCityAttributes");
        throw error;
    }
};

// Update City Attributes
export const updateCityAttributes = async (data: UpdateCityAttributesData) => {
    try {
        return await PostRequest("/api/city_attributes/update", data);
    } catch (error) {
        console.error("Error in updateCityAttributes");
        throw error;
    }
};

// Get City Attributes
export const getCityAttributes = async (data: GetDeleteCityAttributesData): Promise<CityAttributes> => {
    try {
        const payload = {
            city_id: data.city_id,
            neighborhood_id: data.neighborhood_id ?? null,
            ...(data.ao_id && { ao_id: data.ao_id })
        };
        return await PostRequest<CityAttributes>("/api/city_attributes/get", payload);
    } catch (error) {
        console.error("Error in getCityAttributes");
        throw error;
    }
};

// Delete City Attributes
export const deleteCityAttributes = async (data: GetDeleteCityAttributesData) => {
    try {
        return await PostRequest("/api/city_attributes/delete", data);
    } catch (error) {
        console.error("Error in deleteCityAttributes");
        throw error;
    }
};

// Section 2.4.1 - City Parameter Slots APIs

export interface GetSlotData {
    city_id: string;
    slot_number: number;
}

export interface GetAllSlotsData {
    city_id: string;
}

export interface UpdateSlotData extends UpdateCityAttributesData {
    slot_number: number;
}

// Get specific slot
export const getSlot = async (data: GetSlotData): Promise<CityAttributes> => {
    try {
        const response = await PostRequest<any>("/api/city_attributes/get_slot", data);
        // Handle both wrapped and unwrapped responses
        return response.data || response;
    } catch (error) {
        console.error("Error in getSlot");
        throw error;
    }
};

// Get all slots for a city
export const getAllSlots = async (data: GetAllSlotsData): Promise<CityAttributes[]> => {
    try {
        const response = await PostRequest<any>("/api/city_attributes/get_all_slots", data);
        // Handle both wrapped and unwrapped responses
        return response.data || response;
    } catch (error) {
        console.error("Error in getAllSlots");
        throw error;
    }
};

// Update slot
export const updateSlot = async (data: UpdateSlotData) => {
    try {
        return await PostRequest("/api/city_attributes/update_slot", data);
    } catch (error) {
        console.error("Error in updateSlot");
        throw error;
    }
};

// Preview slot update impact
export const previewUpdateSlotImpact = async (data: UpdateSlotData) => {
    try {
        return await PostRequest("/api/city_attributes/preview_update_slot_impact", data);
    } catch (error) {
        console.error("Error in previewUpdateSlotImpact");
        throw error;
    }
};